<template>
    <v-container
      id="dashboard"
      fluid
      tag="section"
    >
    <v-progress-linear
      :class="'progressbar'"
      :active="progressActive"
      indeterminate
      absolute
    />
    <v-alert
      v-model="alertActive"
      :class="'alert'"
      color="error"
      dismissible
      close-icon="mdi-window-close"
    >
      <p>加载错误，原因：</p>
      <p>{{ errorMessage }}</p>
    </v-alert>
    <v-row v-if="!progressActive" :class="'searchbar-row'" align="center">
      <v-col cols="12" md="4" lg="3">
        <v-text-field
          append-icon="mdi-magnify"
          placeholder="搜索"
          hint="用户名或uid"
          v-model="inputText"
          clearable
        />
      </v-col>
      <v-col cols="0" md="6">
      </v-col>
    </v-row>

    <v-lazy>
      <v-row v-if="showList">
        <v-col v-for="streamer in shownStreamers" cols="12" md="4" lg="3" :key="streamer.uid">
          <base-streamer-card :streamer="streamer"></base-streamer-card>
        </v-col>
      </v-row>
    </v-lazy>

    <v-layout justify-center>
      <v-btn v-if="!progressActive && showGetButton" @click="getMoreStreamers" color="green">加载更多</v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'DashboardDashboard',

  metaInfo() {
    return {
      title: `索引`,
    }
  },

  data() {
    return {
      allStreamers: [],
      shownStreamers: [],
      defaultStreamers: [],
      selectedUid: null,
      progressActive: true,
      alertActive: false,
      errorMessage: '',
      dialogActive: false,
      pageNum: 0,
      disableSearch: true,
      inputText: '',
      debounceTimerId: 0,
      showGetButton: true,
      showList: false,
    }
  },

  methods: {
    getMoreStreamers() {
      fetch('https://api.ukamnads.icu/api/v2/channel/filter?type=2&pageSize=48&pageNum=' + this.pageNum)
        .then(resp => resp.json())
        .then(resp => {
          if (resp.code !== 200)
            throw new Error(resp.message)
          let streamers = resp.data.data
          streamers.forEach(streamer => {
            !this.shownStreamers.includes(streamer)
              ? this.shownStreamers.push({ 'uname': streamer.uName, 'uid': streamer.uId, 'avatar': streamer.faceUrl + '@128w_128h' })
              : ''
          })
          this.pageNum += 1
          this.defaultStreamers = this.shownStreamers
        })
        .catch(e => {
          this.errorMessage = '无法获取Danmakus数据：' + e
          this.alertActive = true
        })
    },
  },

  components: {
  },

  created() {
    let totalNum = 0
    fetch('https://api.ukamnads.icu/api/v2/channel?uid=2132180406')
      .then(resp => resp.json())
      .then(resp => {
        this.shownStreamers.unshift({
          uname: resp.data.channel.uName,
          uid: resp.data.channel.uId,
          avatar: resp.data.channel.faceUrl,
        })
      })
    fetch('https://api.ukamnads.icu/api/v2/channel/filter?type=2&pageSize=47&pageNum=' + this.pageNum)
      .then(resp => resp.json())
      .then(resp => {
        if (resp.code !== 200)
          throw new Error(resp.message)
        let streamers = resp.data.data
        streamers.forEach(streamer => {
          this.shownStreamers.push({ 'uname': streamer.uName, 'uid': streamer.uId, 'avatar': streamer.faceUrl + '@128w_128h' })
        })
        this.defaultStreamers = this.shownStreamers
        this.pageNum += 1
        this.showList = true
      })
      .catch(e => {
        this.errorMessage = '无法获取Danmakus数据：' + e
        this.alertActive = true
      })

    if (!this.$streamers) {
      fetch('https://api.ukamnads.icu/api/v2/channels?simple=true')
        .then(resp => resp.json())
        .then(resp => {
          if (resp.code !== 200)
            throw new Error(resp.message)
          let streamers = resp.data
          this.allStreamers = streamers.map(streamer => {
            return { 'uname': streamer.uName, 'uid': streamer.uId, 'avatar': streamer.faceUrl + '@128w_128h' }
          })
          this.disableSearch = false
          this.progressActive = false
          Vue.prototype.$streamers = this.allStreamers
        })
        .catch(e => {
          this.errorMessage = '无法获取Danmakus数据：' + e
          this.alertActive = true
        })
    } else {
      this.allStreamers = this.$streamers
      this.disableSearch = false
      this.progressActive = false
    }
  },

  watch: {
    selectedUid(new_, old) {
      if (new_) {
        this.$router.push('/streamer/' + new_)
      }
    },
    inputText(new_, old) {
      clearTimeout(this.debounceTimerId);
      this.debounceTimerId = setTimeout(() => {
        if (!new_ || old.length >= 1 && new_.length < 1) {
          this.shownStreamers = this.defaultStreamers
          this.showGetButton = true
          return
        }
        if (new_.length < 1)
          return
        this.showGetButton = false
        this.shownStreamers = this.allStreamers.filter(streamer => streamer.uname.toLowerCase().includes(this.inputText.toLowerCase()) || streamer.uid === Number(this.inputText))
      }, 1000);
    },
  }
}
</script>

<style lang="sass">
.alert
  position: fixed
  z-index: 1024
  .v-btn
    background-color: transparent !important
    color: black !important
.searchbar-row
  margin-top: 0px
.progressbar
  margin-top: -12px
</style>